<template>
  <div class="container-fluid py-4 px-4">
    <!--<si-user-table></si-user-table>-->

    <div class="row no-gutters text-left justify-content-between">
      <div class="col-auto py-1">
        <div class="row no-gutters">
          <div class="col-auto">
            <h4 class="font-weight-bold mb-0 mr-3">SI Accounts</h4>
          </div>

          <div class="col-auto">
            <button class="btn btn-sm btn-primary"
                    data-toggle="modal" data-target="#add-user-modal">
              <font-awesome-icon icon="plus"/>
              <span class="ml-1">Add</span>
            </button>
          </div>
        </div>
      </div>
      <div class="col-auto col-lg-5 py-1">
        <div class="input-group input-group-sm">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">
              &#128269;
            </span>
          </div>
          <input type="text"
                 class="form-control"
                 placeholder="Search s.i account here.."
                 aria-label="Search"
                 v-model="formUserData.searchVal"
                 @keydown="callSearchUserDebounce"
                 aria-describedby="basic-addon1">
        </div>
      </div>
      <div class="col-auto py-1">
        <div class="form-group form-inline mb-0">
          <label for="count-vessel" class="col-form-label">Count:</label>
          <div class="col-auto">
            <select class="form-control form-control-sm" name="countVessel" id="count-vessel"
                    v-model="formUserData.count" @change="searchUser">
              <option :value="count" v-for="(count,index) in counts" :key="index">
                <span>{{ count }}</span>
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row no-gutters text-left">
      <div class="col-auto">
        <base-pagination :page-object="userPagination" @settingPage="setPage"></base-pagination>
      </div>
    </div>

    <div class="row no-gutters text-left">
      <base-table :loading="isLoading" :loader-colspan="6" :max-height="650">
        <template slot="table-header">
          <tr>
            <th width="1">#</th>
            <th>LAST NAME</th>
            <th>FIRST NAME</th>
            <th>MIDDLE NAME</th>
            <th>USERNAME</th>
            <th style="width: 240px">ACTION</th>
          </tr>
        </template>
        <template slot="table-body">
          <tr v-if="this.users.length == 0">
            <td colspan="6">No record found</td>
          </tr>
          <tr v-else v-for="(user,index) in users" :key="user.id" :class="{'bg-red-light-9' : !user.active}">
            <td>{{ index + 1 }}</td>
            <td class="text-left pl-lg-3 align-middle">{{ user.last_name }}</td>
            <td class="text-left pl-lg-3 align-middle">{{ user.first_name }}</td>
            <td class="text-left pl-lg-3 align-middle">{{ user.middle_name }}</td>
            <td class="text-left pl-lg-3 align-middle">{{ user.username }}</td>
            <td>
              <div class="dropdown dropleft">
                <button class="btn btn-secondary dropdown-toggle "
                        type="button"
                        id="userDetailsDropdown"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false">
                  Details
                </button>
                <div class="dropdown-menu w-50" aria-labelledby="userDetailsDropdown">
                  <base-outline-info-btn class="sm w-100 mb-1 border-0 text-left px-5"
                                         @click.native="viewDetails(user.id)">
                    <font-awesome-icon icon="ship"/>
                    <span class="ml-1">Vessels</span>
                  </base-outline-info-btn>
                  <hr class="m-0"/>
                  <base-outline-warning-btn class="sm w-100 my-1 border-0 text-left px-5"
                                            data-toggle="modal" data-target="#update-user-modal"
                                            @click.native="editUser(user)">
                    <font-awesome-icon icon="pencil"/>
                    <span class="ml-1">Edit</span>
                  </base-outline-warning-btn>
                  <hr class="m-0"/>
                  <base-outline-danger-btn class="sm w-100 mt-1 border-0 text-left px-5"
                                           @click.native="deleteUser(user.id)">
                    <font-awesome-icon icon="trash"/>
                    <span class="ml-1">Delete</span>
                  </base-outline-danger-btn>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </base-table>
    </div>
    <base-modal modal-id="add-user-modal" modal-title="Add SI User Account" modal-size="md">
      <template v-slot:modal-body>
        <form @submit.prevent="addUser">

          <div class="form-group row mb-1">
            <label for="newUserLastName" class="col-md-3 col-form-label col-form-label-sm font-weight-bold">Last Name
              :</label>
            <div class="col-md-9">
              <input type="text" class="form-control form-control-sm" id="newUserLastName"
                     placeholder="Enter Last Name . . ."
                     v-model="newSIUser.last_name">
            </div>
          </div>

          <div class="form-group row mb-1">
            <label for="newUserFirstName" class="col-md-3 col-form-label col-form-label-sm font-weight-bold">First Name
              :</label>
            <div class="col-md-9">
              <input type="text" class="form-control form-control-sm" id="newUserFirstName"
                     placeholder="Enter First Name . . ."
                     v-model="newSIUser.first_name">
            </div>
          </div>

          <div class="form-group row mb-1">
            <label for="newUserMiddleName" class="col-md-3 col-form-label col-form-label-sm font-weight-bold">Middle
              Name :</label>
            <div class="col-md-9">
              <input type="text" class="form-control form-control-sm" id="newUserMiddleName"
                     placeholder="Enter Middle Name . . ."
                     v-model="newSIUser.middle_name">
            </div>
          </div>

          <div class="form-group row mb-1">
            <label for="newUserEmail" class="col-md-3 col-form-label col-form-label-sm font-weight-bold">Email :</label>
            <div class="col-md-9">
              <input type="email" class="form-control form-control-sm" id="newUserEmail" placeholder="Enter Email . . ."
                     v-model="newSIUser.email">
            </div>
          </div>

          <div class="form-group row mb-1">
            <label for="newUserContact" class="col-md-3 col-form-label col-form-label-sm font-weight-bold">Contact
              Number :</label>
            <div class="col-md-9">
              <input type="number" class="form-control form-control-sm" id="newUserContact"
                     placeholder="Enter Contact . . ."
                     v-model="newSIUser.contact">
            </div>
          </div>

          <div class="form-group row mb-1">
            <label for="newUserUsername" class="col-md-3 col-form-label col-form-label-sm font-weight-bold">Username
              :</label>
            <div class="col-md-9">
              <input type="text" class="form-control form-control-sm" id="newUserUsername"
                     placeholder="Enter Username . . ."
                     v-model="newSIUser.username">
            </div>
          </div>

          <div class="form-group row mb-1">
            <label for="newUserPassword" class="col-md-3 col-form-label col-form-label-sm font-weight-bold">Password
              :</label>
            <div class="input-group col-md-9">
              <input :type="passwordField.password" class="form-control form-control-sm" id="newUserPassword"
                     placeholder="Enter Password . . ."
                     v-model="newSIUser.password">
              <div class="input-group-append">
                <button class="btn btn-sm btn-outline-secondary" type="button" @click="showPassword">
                  <font-awesome-icon :icon="passwordField.passwordIcon" />
                </button>
              </div>
            </div>
          </div>

          <div class="form-group row mb-1">
            <label for="newUserConfirmPassword" class="col-md-3 col-form-label col-form-label-sm font-weight-bold">Confirm
              Password : </label>
            <div class="input-group col-md-9">
              <input :type="passwordField.confirm" class="form-control form-control-sm" id="newUserConfirmPassword"
                     placeholder="Confirm Password . . ."
                     v-model="newSIUser.confirmPassword">
              <div class="input-group-append">
                <button class="btn btn-sm btn-outline-secondary" type="button" @click="showConfirmPassword">
                  <font-awesome-icon :icon="passwordField.confirmIcon" />
                </button>
              </div>
            </div>
          </div>

          <div class="form-group row mb-1">
            <label for="newUserStatus" class="col-auto col-md-3 col-form-label col-form-label-sm font-weight-bold">Active
              :</label>
            <div class="col-auto col-md-9">
              <div class="form-check pt-1">
                <input class="form-check-input" type="checkbox" v-model="newSIUser.active" id="newUserStatus">
              </div>
            </div>
          </div>

          <!-- custom footer since the submit button -->
          <div class="row border-top pt-2">
            <div class="col-12 text-right">
              <base-primary-btn class="sm mx-2" type="submit">
                Save
              </base-primary-btn>
              <base-outline-secondary-btn class="sm" @click.native="closeModal('add-user-modal')">
                Close
              </base-outline-secondary-btn>
            </div>
          </div>
        </form>
      </template>
    </base-modal>

    <base-modal modal-id="update-user-modal" modal-title="Update User Account" modal-size="md">
      <template v-slot:modal-body>
        <form @submit.prevent="updateUser">
          <div class="form-group row mb-1">
            <label for="userLastName" class="col-md-3 col-form-label col-form-label-sm font-weight-bold">Last Name
              :</label>
            <div class="col-md-9">
              <input type="text" class="form-control form-control-sm" id="userLastName"
                     placeholder="Enter Last Name . . ."
                     :disabled="disabledInputFields"
                     v-model="editableUser.last_name">
            </div>
          </div>

          <div class="form-group row mb-1">
            <label for="userFirstName" class="col-md-3 col-form-label col-form-label-sm font-weight-bold">First Name
              :</label>
            <div class="col-md-9">
              <input type="text" class="form-control form-control-sm" id="userFirstName"
                     placeholder="Enter First Name . . ."
                     :disabled="disabledInputFields"
                     v-model="editableUser.first_name">
            </div>
          </div>

          <div class="form-group row mb-1">
            <label for="userMiddleName" class="col-md-3 col-form-label col-form-label-sm font-weight-bold">Middle Name
              :</label>
            <div class="col-md-9">
              <input type="text" class="form-control form-control-sm" id="userMiddleName"
                     placeholder="Enter Middle Name . . ."
                     :disabled="disabledInputFields"
                     v-model="editableUser.middle_name">
            </div>
          </div>

          <div class="form-group row mb-1">
            <label for="userEmail" class="col-md-3 col-form-label col-form-label-sm font-weight-bold">Email :</label>
            <div class="col-md-9">
              <input type="email" class="form-control form-control-sm" id="userEmail" placeholder="Enter Email . . ."
                     :disabled="disabledInputFields"
                     v-model="editableUser.email">
            </div>
          </div>

          <div class="form-group row mb-1">
            <label for="userContact" class="col-md-3 col-form-label col-form-label-sm font-weight-bold">Contact Number
              :</label>
            <div class="col-md-9">
              <input type="number" class="form-control form-control-sm" id="userContact"
                     placeholder="Enter Contact . . ."
                     :disabled="disabledInputFields"
                     v-model="editableUser.contact">
            </div>
          </div>

          <div class="form-group row mb-1">
            <label for="userStatus" class="col-auto col-md-3 col-form-label col-form-label-sm font-weight-bold">Active
              :</label>
            <div class="col-auto col-md-9">
              <div class="form-check pt-1">
                <input class="form-check-input" type="checkbox" id="userStatus"
                       :disabled="disabledInputFields"
                       v-model="editableUser.active">
              </div>
            </div>
          </div>

          <!-- custom footer since the submit button is incorporated into form -->
          <div class="row border-top pt-2">
            <div class="col-12 text-right">
              <template v-if="disabledInputFields">
                <base-warning-btn class="sm mx-2" type="button"
                                  @click.native="toggleEditableFields">
                  <font-awesome-icon icon="pencil"/>
                  <span class="ml-1">Edit</span>
                </base-warning-btn>
                <base-outline-secondary-btn class="sm"
                                            @click.native="closeModal('update-user-modal')">
                  <font-awesome-icon icon="times"/>
                  <span class="ml-1">Close</span>
                </base-outline-secondary-btn>
              </template>
              <template v-else>
                <base-primary-btn class="sm mx-2" type="submit">
                  <font-awesome-icon icon="save"/>
                  <span class="ml-1">Save</span>
                </base-primary-btn>
                <base-outline-danger-btn class="sm" @click.native="toggleEditableFields">
                  <font-awesome-icon icon="cancel"/>
                  <span class="ml-1">Cancel</span>
                </base-outline-danger-btn>
              </template>

            </div>
          </div>
        </form>
      </template>
    </base-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import SiUserTable from '@/components/settings/si-account/siUserTable';
import {AppMixins} from '../../../mixins/app.mixins';
import {AlertService} from "@/service/alert.service";
import __ from 'lodash'

export default {
  name: 'Index',
  components: {SiUserTable},
  /** mixins **/
  mixins: [AppMixins],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {
      newSIUser: {
        'last_name': null,
        'first_name': null,
        'middle_name': null,
        'email': null,
        'contact': null,
        'username': null,
        'active': true,
        'password': null,
        'confirmPassword': null,
      },
      editableUser: {},
      disabledInputFields: true,
      passwordField: {
        password: 'password',
        confirm: 'password',
        passwordIcon: 'eye-slash',
        confirmIcon: 'eye-slash'
      }
    };
  },

  /** methods**/
  methods: {
    ...mapActions(
        [
          'set_user_paginated',
          'getAssignedVessels',
          'addSIUser',
          'deleteSIUser',
          'updateSIUser'
        ]
    ),
    showPassword() {
      this.passwordField.password = this.passwordField.password  === 'password' ? 'text' : 'password'
      this.passwordField.passwordIcon = this.passwordField.passwordIcon === 'eye-slash' ? 'eye' : 'eye-slash'
    },
    showConfirmPassword() {
      this.passwordField.confirm = this.passwordField.confirm === 'password' ? 'text' : 'password'
      this.passwordField.confirmIcon = this.passwordField.confirmIcon === 'eye-slash' ? 'eye' : 'eye-slash'
    },
    loadUsers() {
      // axios.get('http://krbs-tons-api.test/api/tons-v0.0.1/getUserPaginated')
      // .then(({ data }) => (this.users = data.data));
      // axios.get('http://krbs-tons-api.test/api/users').then(response => {
      //   this.usersPaginated = response.data;
      // });
      // axios.get('http://krbs-tons-api.test/api/tons-v0.0.1/getUserPaginated').then(response => {this.users = response.data});
    },

    callSearchUserDebounce : __.debounce(function(){
      this.searchUser();
    },500),

    searchUser() {
      this.set_user_paginated(this.formUserData);
    },

    setPage(e) {
      this.formUserData.page = e;
      this.userPagination.currentPage = e;
      this.set_user_paginated(this.formUserData);
    },

    viewDetails(__id) {
      this.getAssignedVessels(__id);
      this.$nextTick(() => {
        this.$router.push({name: 'SIAccountView', params: {userId: __id}})
      })
    },

    async addUser() {
      let qMsgHtml = '<span>Are you sure you want to add this user account.</span>';
      if (await this.questionFormAlert(`${qMsgHtml}`, 'Add SI User')) {
        this.addSIUser(this.newSIUser).then((r) => {
          if (r) {
            this.set_user_paginated(this.formUserData)
            this.closeModal('add-user-modal')
            this.newSIUser = {
              'active': true,
            }
          }
        })
      }
    },

    closeModal(modalId) {
      const addModal = $('#' + modalId)
      addModal.modal('hide')

    },

    async deleteUser(userId) {
      let qMsgHtml = '<span>Are you sure you want to delete this user account.</span>';
      if (await this.questionFormAlert(`${qMsgHtml}`, 'Delete SI User')) {
        this.deleteSIUser(userId).then((r) => {
          if (r) {
            this.set_user_paginated(this.formUserData)
          }
        })
      }
    },

    editUser(user) {
      this.editableUser = Object.assign({}, user)
    },

    toggleEditableFields() {
      this.disabledInputFields = !this.disabledInputFields
    },

    async updateUser() {
      let qMsgHtml = '<span>Are you sure you want to update this user account.</span>';
      if (await this.questionFormAlert(`${qMsgHtml}`, 'Update SI User')) {
        this.updateSIUser(this.editableUser).then((r) => {
          if (r) {
            this.set_user_paginated(this.formUserData)
            this.closeModal('update-user-modal')
          }
        })
      }
    }
  },

  /**  computed  **/
  computed: {
    ...mapGetters(
        [
          'isLoading',
          'counts',
          'formUserData',
          'users',
          'userPagination',
        ]
    ),
  },

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
    this.set_user_paginated(this.formUserData);
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },

};
</script>

<style scoped lang="scss">

</style>
